import React, { useContext } from 'react';
import IUserMedalInfo from '../../../../interface/userMedal';
import { getMedalIcon } from '@umu/umu-util';
import { AppContext } from '../../../../context/appContext';
import ImageUtil from '../../../utils/imageUtil';
import './userMedalIcon.scss';

interface IUserMedalIconProps {
    userMedalInfo: IUserMedalInfo;
    userMedalWidth: 20 | 30 | 16 | 12;
}

export default function UserMedalIcon(props: IUserMedalIconProps) {
    let size = {};
    const { userMedalWidth, userMedalInfo } = props;
    if (userMedalWidth) {
        size = {
            width: userMedalWidth + 'px',
            height: userMedalWidth + 'px',
        };
    }

    let medalIcon = getMedalIcon(userMedalInfo.medal_type, userMedalInfo.medal_rank, 'S');
    medalIcon = ImageUtil.process(medalIcon || '', {});
    return (
        <div className="user-medal-icon">
            <div className="user-medal" style={size}>
                <div className="img">
                    <img src={medalIcon} alt="" />
                </div>
            </div>
        </div>
    );
}
